import createError from "./ErrorCreate";

export default {
	/**
	 * @description Method to validate some commons errors
	 * @param {Object} err is object contain the error descriptions
	 */
	manageError(err) {
		if (err.data) {
			if (Object.prototype.hasOwnProperty.call(err.data, "reason") && Array.isArray(err.data.reason)) {
				// Implementacion del patron Factory para generar errores segun sea el caso Array o String
				const errorFromArray = createError.call(this, "array", err.data.reason);
				errorFromArray.showError.call(this);
			} else {
				const errorFromArray = createError.call(this, "string", err.data.reason);
				errorFromArray.showError.call(this);
			}
		}
	},
	findErrorNamePropertyValidator() {
		return function validator(error) {
			if (Array.isArray(error.data.reason[0])) {
				return validator(error.data.reason[0][0]);
			}
			const absolute_path = error.data.reason;
			if (absolute_path !== "" && absolute_path !== "Upload id and process_state = 'LOADED' not found") {
				let message = error.data.reason;
				const expresion = /'(.*)'/gm;
				const foundMatch = message.match(expresion);
				return foundMatch ? foundMatch[0].replace(/'/g, "") : message;
			} else {
				return absolute_path;
			}
		};
	},
};
